export const searchLocale = {
    clear: 'Clear',
};
//# sourceMappingURL=Search.locale.js.map